'use strict';

function initPaypal() {
    let isPaypalPromotionEnabled = $('.pp-message').length > 0;
    if (!isPaypalPromotionEnabled) {
        return;
    }
    var isPaypalLoaded = window.paypal;
    if (!isPaypalLoaded) {
        setTimeout(function () {
            initPaypal()
        }, 500)
    } else {
        initEvents();
        $('.pp-message').removeClass('d-none');
        $(document).trigger('pp:loaded', $('.pp-message').data('initial-price'));
    }

}
function initEvents() {
    $(document).on('pp:update pp:loaded', function (event, price) {

        paypal.Messages({
            amount: price,
            placement: "cart",
            style: {
                layout: "text",
                text: {
                    color: "greyscale",
                    size: "11",
                    align: "center"
                },
                logo: {
                    type: "none"
                }
            }
        })
            .render(".pp-message");
    });
}

initPaypal();

